const FleetEvaluatorValues = (props) => {
    const {
        FEAuctionValue,
        FERetailValue,
        FEImagePath, 
        IsDetailsPage: isDetailsPage,
        ShowErrorMessage: showErrorMessage
    } = props;

    const hasFEValues = FEAuctionValue || FERetailValue;

    return (
        hasFEValues || showErrorMessage ?
            <div className={(isDetailsPage ? "dealer-contact " : "") + "evaluator-values"}>
                <img className="evaluator-logo" src={FEImagePath} alt="Fleet Evaluator" />
                {hasFEValues ?
                    <div className="values-container">
                        <div className="evaluator-auction">
                            <span className="evaluator-auction-label">{translator.translate('sandhills.tradesites.mvc.auctionvalue')}:&nbsp;</span>
                            <strong className="evaluator-auction-value">{FEAuctionValue}</strong>
                        </div>
                        <div className="evaluator-retail">
                            <span className="evaluator-retail-label">{translator.translate('sandhills.marketvalue')}:&nbsp;</span>
                            <strong className="evaluator-retail-value">{FERetailValue}</strong>
                        </div>
                    </div>
                    : showErrorMessage ?
                        <div className="no-values-container">{translator.translate('sandhills.novaluesavailable')}</div>
                    : null
                }
            </div>
        : null
    );
};

export default FleetEvaluatorValues;